import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from "components/layout/form/outlinedButton";
import api from "services/api";

import {
  Container,
  ContainerButtons,
  Editar,
  ModalHeader,
  ModalStyle,
  Title,
} from "./styles";

type DebitDeleteModalProps = any;

const DebitDeleteModal = ({
  openModal,
  modalFunction,
  setOpenModalDebit,
  deleteSuccessDA,
}: DebitDeleteModalProps): JSX.Element => {
  const [loading, setLoading] = useState<boolean>();
  const history = useHistory();
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );

  const deleteDebit = async (): Promise<void> => {
    if (!loading) {
      try {
        setLoading(true);
        const headers = {
          access_token: localStorage.getItem(
            "@UltragazEmpresarial:accessToken"
          ),
        };
        const body = {
          hasDirectDebit: false,
        };

        await api.patch(
          `industrial/customer/v1/customers/me/units/${selectedUnit.unitId}`,
          body,
          {
            headers,
          }
        );

        setLoading(false);
        modalFunction(false);
        deleteSuccessDA();
        toast.success("Débito automático excluído com sucesso");
      } catch (err) {
        setLoading(false);
        modalFunction(false);
        if (err.response) {
          const erro = err.response.data;
          if (erro) {
            const { message } = err.response.data;
            const { code } = err.response.data;
            if (err.response.status !== 401 && code !== "422.033") {
              toast.error(message);
            } else {
              setOpenModalDebit(true);
            }
          } else {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        } else {
          setOpenModalDebit(true);
        }
      }
    }
  };

  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Débito automático</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Title>Tem certeza que deseja excluir o Débito automático?</Title>
        <span>
          Essa ação retira sua conta do débito automático e todos os boletos em
          aberto devem ser pagos de forma convencional, você poderá adicionar
          uma nova conta após 2 dias úteis. Se você deseja apenas alterar a
          conta, basta clicar em{" "}
          <Editar onClick={() => history?.push("/debito-automatico")}>
            Editar
          </Editar>
          .
        </span>
        <ContainerButtons>
          <ContainedButton loading={loading} onClick={deleteDebit} block>
            Sim
          </ContainedButton>
          <OutlinedButton onClick={() => modalFunction(false)} block>
            Não
          </OutlinedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default DebitDeleteModal;
